"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _StoreContext = _interopRequireWildcard(require("./StoreContext"));

var ShopifyContextWrapper = function ShopifyContextWrapper(_ref) {
  var children = _ref.children,
      stores = _ref.stores;
  var storeKeys = Object.keys(stores);
  var defaultShop = storeKeys[0] || null;
  var defaultConfig = stores[defaultShop] || null;

  var _useState = (0, _react.useState)((0, _extends2["default"])({
    activeStoreKey: defaultShop
  }, (0, _StoreContext.makeDefaultContext)(defaultConfig))),
      store = _useState[0],
      setStore = _useState[1];

  var changeStore = function changeStore(storeKey) {
    var storeConfig = stores[storeKey];

    if (!storeConfig) {
      console.error("invalid configuration for shop: " + storeKey);
      return;
    }

    setStore((0, _extends2["default"])({
      activeStoreKey: storeKey
    }, (0, _StoreContext.makeDefaultContext)(storeConfig)));
  };

  return _react["default"].createElement(_StoreContext["default"].Provider, {
    value: (0, _extends2["default"])({}, store, {
      storeKeys: storeKeys,
      changeStore: changeStore
    })
  }, children);
};

var _default = function _default(_ref2, pluginOptions) {
  var element = _ref2.element;
  return _react["default"].createElement(ShopifyContextWrapper, {
    stores: pluginOptions.stores
  }, element);
};

exports["default"] = _default;